// extracted by mini-css-extract-plugin
export default {"Integrations":"Integrations_Integrations__IUois"};